import { Component, type ReactNode } from "react";
import { Bee } from "../art/Bee.tsx";
import { Bubble, Button } from "../components/ui.tsx";
import styles from "../screens/Entry.module.css";

/**
 * Catches a crash anywhere below and shows RouteError instead of a blank page. Keyed by the
 * path where it is used, so moving to another page clears the error.
 */
export class RouteErrorBoundary extends Component<
  { children: ReactNode },
  { error: unknown; failed: boolean }
> {
  override state = { error: null as unknown, failed: false };
  static getDerivedStateFromError(error: unknown) {
    return { error, failed: true };
  }
  override render() {
    return this.state.failed ? <RouteError error={this.state.error} /> : this.props.children;
  }
}

/** App-wide error screen (C23): friendly for the child, details folded away for the parent. */
export function RouteError({ error }: { error: unknown }) {
  const detail = error instanceof Error ? error.message : String(error);
  return (
    <div className={styles.page}>
      <Bee expression="oops" size={150} />
      <Bubble>Ối, tớ bị vấp một chút. Cậu bấm “Thử lại” nhé!</Bubble>
      <div className={styles.actions}>
        <Button size="l" block onClick={() => window.location.reload()}>
          Thử lại
        </Button>
        <Button variant="ghost" block onClick={() => window.location.assign("/ban-do")}>
          Về trang chủ
        </Button>
      </div>
      <details className={styles.note}>
        <summary>Thông tin cho bố mẹ</summary>
        <code>{detail}</code>
      </details>
    </div>
  );
}
